import type { FeatureConfig } from '@/core/registry';
import graphsRoutes from './routes';
import graphsLocales from './locales';
import { graphsHandlers } from './mocks';
import { GRAPH_PERMISSIONS } from './constants/permissions.constants';

const config: FeatureConfig = {
  routes: graphsRoutes,
  locales: { ns: 'graphs', resources: graphsLocales },
  handlers: graphsHandlers,
  permissions: GRAPH_PERMISSIONS,
};

export default config;
